import {
  localSave,
  localRead
} from "@/libs/util";

import {saveErrorLogger,webLogo,serverMac} from '@/api/data'
//import config from '@/config'
//const {homeName} = config
export default {
  state: {
    local: localRead('local'),
    errorList: [],
    hasReadErrorPage: false,
    logoPath:localRead('logoPath'),
    txtLogo: '',
    loginBg: localRead('loginBg'),
    hasGisVideoAuth: false,
    // 首屏即用视口尺寸，避免 Control 等页面在 Main.getScreenInfo 之前用空宽高算出 0 侧栏
    sysHeight: (typeof window !== 'undefined'
      ? (window.innerHeight || document.documentElement.clientHeight || 0)
      : 0),
    sysWidth: (typeof window !== 'undefined'
      ? (window.innerWidth || document.documentElement.clientWidth || 0)
      : 0),
    webVersion:'',
    mac:'',
    theme: (function () {
      try {
        return localStorage.getItem('theme') || localStorage.getItem('className') || 'blue'
      } catch (e) {
        return 'blue'
      }
    })(),
    autoAccept:false,
    acceptType:'auto',
    isOpenLogo:false,
    serverTime: null,
  },
  mutations:{
    setWebVersion(state, webVersion) {
      state.webVersion = webVersion
    },
    setAcceptType(state,acceptType){
      state.acceptType = acceptType
    },
    setServerTime(state,serverTime) {
      state.serverTime = serverTime
    },
    setAutoAccept(state,autoAccept){
      state.autoAccept = autoAccept
    },
    setLocal (state, lang) {
      localSave('local', lang)
      state.local = lang
    },
    setTheme(state, theme) {
      if (['black', 'white', 'blue'].indexOf(theme) > -1) {
        state.theme = theme
      }
    },
    setTxtLogo(state,txtLogo) {
      state.txtLogo = txtLogo
    },
    addError(state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus(state, status = true) {
      state.hasReadErrorPage = status
    },
    setLogoPath(state, logoPath) {
      localSave('logoPath', logoPath)
      state.logoPath = logoPath
    },
    setSysHeight(state, sysHeight) {
      state.sysHeight = sysHeight
    },
    setSysWidth(state, sysWidth) {
      state.sysWidth = sysWidth
    },
    setMac(state,mac){
      state.mac = mac
    },
    setIsOpenLogo(state,isOpenLogo){
      state.isOpenLogo = isOpenLogo
    },
    setLoginBg(state, loginBg) {
      localSave('loginBg', loginBg)
      state.loginBg = loginBg
    },
    setHasGisVideoAuth(state, hasGisVideoAuth) {
      state.hasGisVideoAuth = hasGisVideoAuth
    }
  },
  actions: {
    addErrorLog({commit, rootState}, info) {
      if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false)
      const {user: {token, userId, userName}} = rootState
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      }
      saveErrorLogger(info).then(() => {
        commit('addError', data)
      })
    },
    LogoPath({commit}) {
      return new Promise((resolve, reject) => {
        webLogo().then((res) => {
          let data = res.data
          let status = data.code
          let flag = true;
          if (status === 200) {
            if (data.data !== null) {
              let logoList = data.data;
              let temp = ''
              let wt = ''
              let hasLoginBg = false
              for (let i = 0; i < logoList.length; i++) {
                let logo = logoList[i]
                if (logo.logoType === 'WebLogo') {
                  wt = logo.logoUrl
                  commit('setLogoPath', logo.logoUrl)
                }
                if (logo.logoType === 'TXTLogo') {
                  flag = false;
                  commit('setIsOpenLogo', true)
                  commit('setTxtLogo', logo.logonName)
                }
                if (logo.logoType === 'ClientLogo') {
                  temp = logo.logoUrl
                }
                if (logo.logoType === 'LoginBg') {
                  hasLoginBg = true
                  commit('setLoginBg', logo.logoUrl)
                }
              }
              if (!hasLoginBg) {
                commit('setLoginBg', '')
              }
              if (!wt) {
                commit('setLogoPath', temp)
              }

            }
          }
          if(flag){
            commit('setIsOpenLogo', true)
            commit('setTxtLogo', "")
          }
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })

    },
    serverMac({commit},{auth,timestamp}){
      return new Promise((resolve, reject) => {
        serverMac({auth,timestamp}).then(res=>{
          let response = res.data
          if (response.statuscode === '000000' || response.code === 200) {
            commit('setMac',response.data)
            resolve(response.data)
          }else{
            reject()
          }
        })
      })

    }
  }

}



// WEBPACK FOOTER //
// ./src/store/module/app.js